export const CUSTOMER_ACTIONS = {
  SET_STATE: "customer/setState",
  GET_CUSTOMER: "customer/getCustomer",
  GET_CUSTOMER_BY_ID: "customer/getCustomerById",
  CREATE_CUSTOMER: "customer/createCustomer",
  UPDATE_CUSTOMER: "customer/updateCustomer",
  UPDATE_CUSTOMER_PASSWORD: "customer/updateCustomerPassword",
  DELETE_CUSTOMER: "customer/deleteCustomer",
};
